const currentYear = new Date().getFullYear();

export const frCustomMessages = {
    oui: 'Oui',
    non: 'Non',
    action_annuler: 'Annuler',
    action_sauver: 'Sauver',
    //------------------------------------------------------------------------------------------------------------------
    // Menu
    //------------------------------------------------------------------------------------------------------------------
    fichier: 'Fichier',
    ouvrir: 'Ouvrir',
    sauver: 'Sauver',
    exportPDF: 'Exporter en PDF',
    //------------------------------------------------------------------------------------------------------------------
    menu: 'Menu',
    lectureMenu: 'Mode lecture',
    editMenu: 'Mode édition',
    reorderingMenu: 'Mode réarrangement',
    //------------------------------------------------------------------------------------------------------------------
    libelleMenu: "Libellé",
    //------------------------------------------------------------------------------------------------------------------
    // Confirmation delete
    //------------------------------------------------------------------------------------------------------------------
    confirmation_delete_titre: "Confirmation de suppression",
    confirmation_delete_question: "Êtes-vous sûr de vouloir supprimer « {VAR} » ?",
    confirmation_delete_enfant: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} element.",
    confirmation_delete_enfants: "Je vous informe également que ça supprimera tous les enfants, c'est-à-dire {VAR} elements.",
    //------------------------------------------------------------------------------------------------------------------
    // Icon
    //------------------------------------------------------------------------------------------------------------------
    icon_titre: "Sélection de l'icône",
    icon_msg_pour: "Ceci changera l'icône pour « {VAR} ».",
    //------------------------------------------------------------------------------------------------------------------
    // Settings
    //------------------------------------------------------------------------------------------------------------------
    parametres: 'Paramètres',
    choixCouleur: 'Choisir une couleur de mise en évidence :',
    //------------------------------------------------------------------------------------------------------------------
    greeting: "Bonjour, Maria !",
    welcome: "Bienvenue de retour",
    search: "Rechercher",
    aiAssistant: "Assistant IA",
    overview: "Aperçu",
    earnings: "Revenus",
    spendings: "Dépenses",
    thanLastMonth: "par rapport au mois dernier",
    savings: "Épargnes",
    education: "Éducation",
    dreamHome: "Maison de rêve",
    car: "Voiture",
    holidays: "Vacances",
    healthcare: "Santé",
    budgetUtilization: "Utilisation du budget",
    budgetUsed: "50% du budget utilisé",
    totalBudget: "Budget total",
    usedBudget: "Budget utilisé",
    transactions: "Transactions",
    pdfExport: "Exporter en PDF",
    excelExport: "Exporter en Excel",
    personalTransactions: "Transactions personnelles",
    transactionDetails: "Détails de la transaction",
    merchant: "Commerçant",
    orderStatus: "État de la commande",
    time: "Heure",
    customer: "Client",
    email: "E-mail",
    paymentMethod: "Méthode de paiement",
    transactionHash: "Hash de transaction",
    from: "De",
    to: "À",
    investments: "Investissements",
    totalInvestments: "Investissements totaux",
    stocks: "Actions",
    realEstates: "Immobilier",
    bonds: "Obligations",
    mutualFunds: "Fonds communs",
    cryptocurrency: "Cryptomonnaie",
    commodities: "Matières premières",
    todayMovers: "Top 5 des mouvements du jour",
    stockChart: "Graphique des actions",
    value: "Valeur",
    volume: "Volume",
    analytics: "Analytique",
    moneyCashflow: "Flux de trésorerie",
    year: "Année",
    month: "Mois",
    personalInformation: "Informations personnelles",
    settings: "Paramètres",
    calendar: "Calendrier",
    cardInformation: "Informations de carte",
    weather: "Météo",
    save: "Enregistrer",
    restore: "Restaurer",
    name: "Prénom",
    surname: "Nom",
    tag: "Étiquette",
    birthday: "Date de naissance",
    country: "Pays",
    address: "Adresse",
    postCode: "Code postal",
    bank: "Banque",
    expirationDate: "Date d'expiration",
    cardHolder: "Titulaire de la carte",
    cardNumber: "Numéro de carte",
    partlyCloudy: "Partiellement nuageux",
    humidity: "Humidité",
    dew: "Rosée",
    pressure: "Pression",
    windSpeed: "Vitesse du vent",
    footer: `Copyright © ${currentYear} Progress Software. Tous droits réservés.`,
    home: "Accueil",
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",
    relatedTopics: "Sujets connexes",
    chatWithRoby: "Discuter avec Roby",
};

export const frComponentMessages = {
    // Grid
    "kendo.grid.groupPanelEmpty":
        "Faites glisser un en-tête de colonne ici pour grouper par cette colonne",
    "kendo.grid.noRecords": "Aucun enregistrement disponible.",
    "kendo.grid.pagerFirstPage": "Aller à la première page",
    "kendo.grid.pagerPreviousPage": "Aller à la page précédente",
    "kendo.grid.pagerNextPage": "Aller à la page suivante",
    "kendo.grid.pagerLastPage": "Aller à la dernière page",
    "kendo.grid.pagerPage": "Page",
    "kendo.grid.pagerOf": "sur",
    "kendo.grid.pagerItems": "éléments",
    "kendo.grid.pagerItemsPerPage": "éléments par page",
    "kendo.grid.pagerPageNumberInputTitle": "Numéro de page",
    "kendo.grid.filter": "Filtrer",
    "kendo.grid.filterEqOperator": "Est égal à",
    "kendo.grid.filterNotEqOperator": "N'est pas égal à",
    "kendo.grid.filterIsNullOperator": "Est nul",
    "kendo.grid.filterIsNotNullOperator": "N'est pas nul",
    "kendo.grid.filterIsEmptyOperator": "Est vide",
    "kendo.grid.filterIsNotEmptyOperator": "N'est pas vide",
    "kendo.grid.filterStartsWithOperator": "Commence par",
    "kendo.grid.filterContainsOperator": "Contient",
    "kendo.grid.filterNotContainsOperator": "Ne contient pas",
    "kendo.grid.filterEndsWithOperator": "Se termine par",
    "kendo.grid.filterGteOperator": "Est supérieur ou égal à",
    "kendo.grid.filterGtOperator": "Est supérieur à",
    "kendo.grid.filterLteOperator": "Est inférieur ou égal à",
    "kendo.grid.filterLtOperator": "Est inférieur à",
    "kendo.grid.filterIsTrue": "est vrai",
    "kendo.grid.filterIsFalse": "est faux",
    "kendo.grid.filterBooleanAll": "(Tous)",
    "kendo.grid.filterAfterOrEqualOperator": "Est après ou égal à",
    "kendo.grid.filterAfterOperator": "Est après",
    "kendo.grid.filterBeforeOperator": "Est avant",
    "kendo.grid.filterBeforeOrEqualOperator": "Est avant ou égal à",
    "kendo.grid.filterFilterButton": "Filtrer",
    "kendo.grid.filterClearButton": "Effacer",
    "kendo.grid.filterAndLogic": "Et",
    "kendo.grid.filterOrLogic": "Ou",
    "kendo.grid.filterDateToggle": "Basculer le calendrier",
    "kendo.grid.filterDateToday": "Aujourd'hui",
    "kendo.grid.filterNumericDecrement": "Diminuer la valeur",
    "kendo.grid.filterNumericIncrement": "Augmenter la valeur",
    "kendo.grid.loading": "Chargement",
    "kendo.grid.sort": "Trier",
    "kendo.grid.columnMenu": "Menu de colonne",
    "kendo.grid.columns": "Colonnes",
    "kendo.grid.lock": "Verrouiller",
    "kendo.grid.unlock": "Déverrouiller",
    "kendo.grid.stick": "Épingler",
    "kendo.grid.unstick": "Détacher",
    "kendo.grid.setColumnPosition": "Définir la position de la colonne",
    "kendo.grid.sortAscending": "Trier par ordre croissant",
    "kendo.grid.sortDescending": "Trier par ordre décroissant",
    "kendo.grid.columnsApply": "Appliquer",
    "kendo.grid.columnsReset": "Réinitialiser",
    "kendo.grid.sortable": "Triable",
    "kendo.grid.sortedAscending": "Trié par ordre croissant",
    "kendo.grid.sortedDescending": "Trié par ordre décroissant",
    "kendo.grid.sortedDefault": "Non trié",

    // DropDowns
    "kendo.autocomplete.noDataText": "Aucune donnée trouvée",
    "kendo.autocomplete.clearTitle": "Effacer",
    "kendo.combobox.noDataText": "Aucune donnée trouvée",
    "kendo.combobox.clearTitle": "Effacer",
    "kendo.dropdownlist.noDataText": "Aucune donnée trouvée",
    "kendo.dropdownlist.clearTitle": "Effacer",

    // Calendar
    "kendo.calendar.today": "AUJOURD'HUI",

    // TextBox
    "kendo.textbox.clearTitle": "Effacer",

    // DatePicker
    "kendo.datepicker.today": "AUJOURD'HUI",
    "kendo.datepicker.toggle": "Basculer le calendrier",

    // DateInput
    "kendo.dateinput.increment": "Augmenter la valeur",
    "kendo.dateinput.decrement": "Diminuer la valeur",

    // NumericTextBox
    "kendo.numerictextbox.increment": "Augmenter la valeur",
    "kendo.numerictextbox.decrement": "Diminuer la valeur",

    // AIPrompt
    "kendo.aiprompt.generateOutput": "Générer",
    "kendo.aiprompt.copyOutput": "Copier",
    "kendo.aiprompt.retryGeneration": "Réessayer",
    "kendo.aiprompt.outputView": "Résultat",
    "kendo.aiprompt.promptView": "DEMANDER À L'IA",
    "kendo.aiprompt.promptPlaceholder": "Comment...",
    "kendo.aiprompt.promptSuggestions": "Suggestions",
};